import { SYSAction, SYSScreen } from "../../../../../_ovlclient/src"
import { Data } from "../../../../../_ovlclient/src/dataapi"
import { MergeDeep } from "../../../../../_ovlclient/src/global/actions"
import {
  ProcessStart,
  ProcessEnd,
} from "../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"
import { TogglePDFPopupState } from "../parts/filelist/filelist"

const TogglePDFPopup: SYSAction<TogglePDFPopupState> = (value) => {
  if (value.obj.activeFilePopup === value.key) {
    value.obj.activeFilePopup = ""
  } else {
    value.obj.activeFilePopup = value.key
  }
}

const HandleRefresh: SYSAction<{
  screen: SYSScreen
  context: any
}> = async ({ screen, context }, { global }) => {
  let actions = global.getActions()
  //call the screens refresh action if any
  await actions.app.screens[screen].hooks["HookScreenRefresh"](context)
}

const HandleDataRefresh: SYSAction = async (_, { global }) => {
  ProcessStart("GENRefreshData")
  try {
    // 1st get global data to be refreshed
    let state = global.getState()
    let res = await Data("data/getdata")
    if (!res.data) {
      return
    }
    if (!state.app.global.DAT.partner) {
      //@ts-ignore
      state.app.global.DAT.partner = {}
      //@ts-ignore
    }
    state.app.global.GEN.lookups.weekAndDate = res.data.weekAndDateLookup
    state.app.global.DAT.partner.mainAttachments = res.data.mainAttachments
    state.app.global.DAT.partner.partnerAttachments =
      res.data.partnerAttachments

    state.app.global.DAT.counts = {
      invoiceCount: res.data.invoiceCount,
      quotationCount: res.data.quotationCount,
      orderCount: res.data.orderCount,
    }
  } finally {
    ProcessEnd("GENRefreshData")
  }
}

export let actions = { TogglePDFPopup, HandleRefresh, HandleDataRefresh }
